/// <amd-module name="Artifacts/Root/types/IFeedView" />

/**
 * A view on top of a feed.
 */
export interface IFeedView {
  /**
   * Id of the view.
   */
  id: string;
  /**
   * Name of the view.
   */
  name: string;
  /**
   * Type of view.
   */
  type: any;
  /**
   * Visibility status of the view (permissions).
   */
  visibility: any;
  /**
   * Indicates whether the view is set as the default view.
   */
  isDefaultView: boolean;
}
